import ProductGallery from "util/ProductGallery";
import {svg_include} from "index";
import Page from "webPage/Page";
import GlobalEvents from "base/GlobalEvents";

export default class Product {

    constructor($element) {
        this.$element = $element;
        this.$gallery = this.$element.find('.js-product-gallery');
        this.$image_element = this.$element.find('.js-product-gallery-sticky');

        this.variations = [];

        this.gallery = null;

        this.onResize = this.onResize.bind(this);

        this.loadVariationsData();
        this.bindEvents();

        $(window).on('resize', this.onResize);

        this.onResize();

        this.updateAvailableAttributes();

        if (this.gallery === null) {
            this.createGallery();
            this.updateImageStickyState();
        }

        this.updateFromQueryString();
    }


    bindEvents() {
        let me = this;

        this.$element.on('change', '.js-variation-attribute-value', function () {
            const $this = $(this);
            const attribute = $this.attr("name");
            const value = $this.attr("value");

            let selected_attributes = me.getSelectedAttributes();
            selected_attributes[attribute] = value;

            if (me.getVariation(selected_attributes) === null) {
                // There is no matching variation for these attributes, lets force using the one we have

                const matching_variations = me.getMatchingVariations({[attribute]: value}, true);

                const variation = matching_variations.length === 0 ? me.variations[0] : matching_variations[0];
                selected_attributes = variation.attributes;
            }

            me.selectAttributes(selected_attributes);
            me.updateAvailableAttributes();

            let url = me.getCurrentVariationUrl();
            history.pushState({}, '', url);

            $('#input_2_21').val(url);

            me.updateProduct();
            return false;
        }).on('click', '.js-show-quote-modal', function () {
            $('body').addClass('modal-active');
            $('.js-quote-modal').addClass('modal--active');

            return false;
        }).on('click', '.js-close-modal', function () {
            $('body').removeClass('modal-active');
            $('.js-quote-modal').removeClass('modal--active');
        }).on('click', '.js-toggle-accordion', function () {
            $(this).closest($(".js-accordion-wrap")).toggleClass("accordion--active");
            $(this).next($(".accordion__text")).stop().slideToggle();
        });

        $(document).bind('gform_post_render', function () {
            let gfRecaptchaPoller = setInterval(function () {
                if (!window.grecaptcha || !window.grecaptcha.render) {
                    return;
                }
                if ($('.ginput_recaptcha').length <= 0) {
                    return;
                }
                setTimeout(function () {
                    console.log("rerender recaptcha")
                    renderRecaptcha();
                    clearInterval(gfRecaptchaPoller);
                });
            }, 100);
        });


        window.onpopstate = function (event) {
            me.updateFromQueryString();
        };

        GlobalEvents.on('updatedStickyNavOffset', (offset) => {
            this.updateStickyImageOffset(offset);
        });
    }

    updateFromQueryString() {
        let queryString = Page.get_query();

        if (Object.keys(queryString).length === 0) {
            return;
        }

        this.selectAttributes(queryString);
        this.updateProductDetails(this.getVariation(queryString));
        this.updateAvailableAttributes();

        let url = this.getCurrentVariationUrl();
        $('#input_2_21').val(url);
    }

    createGallery() {
        if (this.gallery !== null && 'undefined' !== typeof this.gallery.destroy) {
            this.gallery.destroy();
        }

        this.gallery = new ProductGallery(this.$gallery);
    }

    /**
     * @return {string} The URL of the currently selected variation
     */
    getCurrentVariationUrl() {
        let url = window.location.origin + window.location.pathname;
        let attributes = this.getSelectedAttributes();

        if (Object.keys(attributes).length > 0) {
            url += '?' + $.param(attributes);
        }

        return url;
    }

    /**
     * @param {Object<string, string>} attributes
     * @param {boolean} partial_matches Whether to allow partial matches
     * @return {Array<Object>}
     */
    getMatchingVariations(attributes, partial_matches = false) {
        const matches = [];

        variationsLoop: for (let variation of this.variations) {
            if (partial_matches === false && Object.keys(variation.attributes).length !== Object.keys(attributes).length) {
                // This variation has a different number of variations
                continue;
            }

            for (let [attribute, value] of Object.entries(attributes)) {
                if ('undefined' === typeof variation.attributes[attribute]) {
                    // This variation doesn't have this attribute selected, try the next one
                    continue variationsLoop;
                }

                if (variation.attributes[attribute] !== value) {
                    // This variation doesn't have the same value for this attribute, try the next one
                    continue variationsLoop;
                }
            }

            // All the attributes match, this is the variation
            matches.push(variation);
        }

        return matches;
    }

    /**
     *
     * @return {Object<string, string>} The map of currently selected attributes
     */
    getSelectedAttributes() {
        const attributes = {};

        this.$element.find('.js-variation-attribute-value:checked').each((_, el) => {
            const $el = $(el);
            attributes[$el.attr('name')] = $el.attr('value');
        });

        return attributes;
    }

    /**
     * @param {Object<string, string>} attributes
     * @param {boolean} partial_matches Whether to allow partial matches
     * @return {null|Object}
     */
    getVariation(attributes, partial_matches = false) {
        const matches = this.getMatchingVariations(attributes, partial_matches);

        if (matches.length !== 1) {
            return null;
        }

        return matches[0];
    }

    loadVariationsData() {
        let $variations = this.$element.find('.js-variations-data');
        if ($variations.length > 0) {
            try {
                this.variations = JSON.parse($variations.text());
            } catch (e) {
                console.log(e);
            }

            this.updateProduct();
        } else {
            this.createGallery();
        }
    }

    onResize() {
        this.updateImageStickyState();
    }

    selectAttributes(attributes) {
        for (let [key, value] of Object.entries(attributes)) {
            this.$element.find(".js-variation-attribute-value[name='" + key + "'][value='" + value + "']").prop("checked", true);
        }
    }

    /**
     * Update the enabled state of all attributes taking the currently selected options into account
     */
    updateAvailableAttributes() {
        const selected_attributes = this.getSelectedAttributes();

        // Loop through each attribute
        for (let attribute of Object.keys(selected_attributes)) {
            // Take a copy of the selected attributes
            const match_attributes = Object.assign({}, selected_attributes);

            // Remove the current attribute that we've got selected
            delete match_attributes[attribute];

            // Get all the variations that have all the other attributes selected
            const matching_variations = this.getMatchingVariations(match_attributes, true);

            const $attributes = this.$element.find(".js-variation-attribute-value[name='" + attribute + "']");
            $attributes.parent().addClass("attributes-radio--unavailable");

            const available_values_map = {};

            // Loop through all the variations that matched, making an note of each value we see for this attribute
            for (let variation of matching_variations) {
                // This variation doesn't have the attribute selected
                if ('undefined' === typeof variation.attributes[attribute]) {
                    continue;
                }

                available_values_map[variation.attributes[attribute]] = true;
            }

            // Mark all the values that we saw as available
            for (let available_value of Object.keys(available_values_map)) {
                $attributes.filter("[value='" + available_value + "']").parent().removeClass("attributes-radio--unavailable");
            }
        }
    }

    updateGalleryImages(images) {
        this.$gallery.html('');

        let $gallery_main = $(eotwJSXFactory('div', {className: "gallery__main-wrap js-items"}));
        let $track = $(eotwJSXFactory('div', {className: "slider__track js-track"}));

        images.forEach((image, index) => {

            $gallery_main.append(
                eotwJSXFactory('div', {className: "gallery__main-image " + (index === 0 ? 'gallery__main-image--active' : ''), unsafeHtml: image.full}),
            );

            if (images.length > 1) {
                $track.append(
                    eotwJSXFactory('button', {type: "button", className: "js-track-item gallery__thumb " + (index === 0 ? 'gallery__thumb--active' : ''), unsafeHtml: image.full}),
                );
            }
        });

        let $actions = '';

        if (images.length > 1) {
            $actions = $(
                eotwJSXFactory('div', {className: "gallery__actions"}, [
                    eotwJSXFactory('div', {className: "gallery__button"}, [
                        eotwJSXFactory('button', {type: "button", 'data-direction': "backwards", className: "arrow-btn arrow-btn--gallery js-navigate", unsafeHtml: svg_include('arrow-btn')})
                    ]),
                    eotwJSXFactory('div', {className: "gallery__button"}, [
                        eotwJSXFactory('button', {className: "arrow-btn arrow-btn--gallery arrow-btn--next js-navigate", 'data-direction': "forwards", unsafeHtml: svg_include('arrow-btn')})
                    ])
                ]),
                eotwJSXFactory('div', {className: "gallery__text"}, [eotwJSXFactory('span', {className: "js-active-number"}, ["1"]),"/", images.length]),
            );
        }

        this.$gallery.append(
            eotwJSXFactory('div', {className: "gallery__main"}, [
                $gallery_main,
                $actions
            ]),
        );

        this.$gallery.append(
            eotwJSXFactory('div', {className: "gallery__thumbs js-pips js-track-wrap slider"}, [
                eotwJSXFactory('div', {className: "slider__inner-wrap js-outer-wrap"}, [
                    $track
                ])
            ]),
        );

        this.createGallery();
        this.updateImageStickyState();
    }

    updateImageStickyState() {
        let isSticky = this.imageIsSticky();
        this.$image_element.toggleClass('sticky-content--product-image--sticky', isSticky);
    }

    imageIsSticky() {
        let height = $(window).height() - 20;

        let isSticky = height > (this.$image_element.height() + 80); //To account for the sticky nav;

        return isSticky && this.$image_element.height() < this.$element.find('.js-product-description').height(); //Image section is taller than text so shouldn't be sticky
    }

    updateProduct() {
        let attributes = this.getSelectedAttributes();

        this.updateProductDetails(this.getVariation(attributes));
    }

    updateProductDetails(variation) {
        if (variation === null) {
            return;
        }

        //Update price
        if ('undefined' !== typeof variation.price_html) {
            this.$element.find('.js-product-price').html(variation.price_html);
        }

        if ('undefined' !== typeof variation['gallery_images']) {
            this.updateGalleryImages(variation['gallery_images']);
        }

        if ('undefined' !== typeof variation.sku) {
            this.$element.find('.js-value[data-value="sku"]').text(variation.sku);
        }

        if ('undefined' !== typeof variation['variation_description']) {
            this.$element.find('.js-variation-description').html(variation['variation_description']);
        }

        if ('undefined' !== typeof variation['dimensions_html']) {
            let $element = this.$element.find('.js-value[data-value="dimensions"]');

            $element.html(variation['dimensions_html']);

            let label_text = 'Dimensions (';

            let labels = [];

            if (variation['dimensions']['length'] !== '') {
                labels.push('L');
            }
            if (variation['dimensions']['width'] !== '') {
                labels.push('W');
            }
            if (variation['dimensions']['height'] !== '') {
                labels.push('H');
            }

            label_text += labels.join(' x ') + ')';

            $element.parent().find('th').text(label_text);

            if (variation['dimensions_html'] !== '' && variation['dimensions_html'] !== 'N/A') {
                $element.parent().show();
            } else {
                $element.parent().hide();
            }
        }

        if ('undefined' !== typeof variation['engraving_area_html']) {
            let $element = this.$element.find('.js-value[data-value="engraving_area"]');

            $element.html(variation['engraving_area_html']);

            if (variation['engraving_area_html'] && variation['engraving_area_html'] !== '' && variation['engraving_area_html'] !== 'N/A') {
                $element.parent().show();
            } else {
                $element.parent().hide();
            }
        }

        if ('undefined' !== typeof variation['weight_html']) {
            let $element = this.$element.find('.js-value[data-value="weight"]');

            $element.html(variation['weight_html']);

            if (variation['weight_html'] !== '' && variation['weight_html'] !== 'N/A') {
                $element.parent().show();
            } else {
                $element.parent().hide();
            }
        }
    }

    updateStickyImageOffset(offset) {
        if (Number.isNaN(offset)) {
            offset = 0;
        }

        offset = Math.max($('.js-header .header__bg').outerHeight() - Math.abs(offset), 0) + 20;

        if (!this.imageIsSticky()) {
            offset = 0;
        }

        this.$image_element.css({'top': offset + 'px'});
    }
}